import { apiRequest } from '@glow/shared/lib/http';
import { useInvalidatingMutation } from '@glow/shared/lib/vueQuery';
import { type Chat } from '../types';
import { chatKeys } from './keys';

export function getOrCreateUserChat(userId: number) {
  return apiRequest<Chat>('get', `/users/${userId}/chat`);
}

export function useGetOrCreateUserChat() {
  return useInvalidatingMutation(
    chatKeys.all,
    ({ userId }: { userId: number }) => getOrCreateUserChat(userId)
  );
}
